import { useTranslation } from 'react-i18next'

import { dataLayerPublish } from '@dhl/datalayer'
import { usePutProfileMobilePhoneVerify, type VerifyMobilePhoneRequest } from '@dhl/receiver-profile-api'
import { useSnackbar } from '@dhl-ui/components'

export const useVerifyProfileMobileNumber = () => {
  const { mutateAsync: verifyProfileMobileNumber } = usePutProfileMobilePhoneVerify()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  return async (values: VerifyMobilePhoneRequest): Promise<void> => {
    try {
      await verifyProfileMobileNumber({
        data: values,
      })
      enqueueSnackbar(t('portal.profile.mobileNumberPage.mobileNumberVerificationDone'), {
        severity: 'success',
      })
    } catch (error) {
      dataLayerPublish('ERROR', { error, page: 'verify-mobile-number' })

      throw error
    }
  }
}
